import { handleActions } from 'redux-actions'

import * as flashActions from '../actions/flash'

import { InitialFlashValue } from '../common/flash'

const defaultValue = InitialFlashValue

export default handleActions(
  {
    [flashActions.onFlashUpdate.toString()](state, action: ReturnType<typeof flashActions.onFlashUpdate>) {
      return action.payload
    },
  },
  defaultValue
)
